import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Grid, Heading, Box, Container, Button, Text} from '@tenancy.nz/ui';
import ErrorImage from './ErrorImage';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
    this.resetState = this.resetState.bind(this);
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(error);
    // eslint-disable-next-line no-console
    console.error(errorInfo);
  }

  resetState() {
    this.setState({hasError: false});
    // eslint-disable-next-line react/destructuring-assignment
    this.props.resetState();
  }

  render() {
    const {hasError} = this.state;
    const {children} = this.props;
    if (hasError) {
      return (
        <Container maxWidth="sm">
          <Box
            sx={{
              p: 5,
            }}>
            <Grid container alignItems="center">
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    py: 5,
                  }}>
                  <Heading
                    as="h1"
                    gutterBottom
                    color="primary"
                    align="center"
                    sx={{fontSize: 78}}>
                    On no!
                  </Heading>
                  <Text
                    color="primary"
                    align="center"
                    sx={{fontSize: 24, textAlign: 'center'}}>
                    Something went wrong. Please refresh the page and try again.
                    If you&apos; still have issues, we are here to help so
                    don&apos;t hesitate{' '}
                    <a
                      href="https://tenant.co.nz/contact/"
                      target="_blank"
                      color="inherit"
                      rel="noopener noreferrer">
                      contact us
                    </a>
                    .
                  </Text>
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Box
                        sx={{
                          p: 5,
                        }}>
                        <Button onClick={this.resetState}>Try again</Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    py: 5,
                  }}>
                  <ErrorImage src="images/crying.jpg" />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.shape({
    doh: PropTypes.string,
    sorry: PropTypes.string,
    lol: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  resetState: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  resetState: () => dispatch({type: 'RESET'}),
});

export default connect(null, mapDispatchToProps)(ErrorBoundary);
